import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { ServiceBenefits } from './types';

export function useServiceBenefitsData(): Page<ServiceBenefits>['templateFields'] {
  return useCurrentPage<Page<ServiceBenefits>>().templateFields;
}
